import React from "react";
// import "./NavBar.css";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        © 2025 Savannah Chanel | Built with React + CSS + 🤍 + ☕️ | Hosted on
        Vercel
      </p>
    </footer>
  );
}
